import { useContext, useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { fetchCompany } from "../services/fetchCompany"
import { renderImgUrl } from "../utils/renderImgUrl"
import { PiBuildingOfficeBold } from "react-icons/pi";
import { LuMapPin } from "react-icons/lu";
import { GoPeople } from "react-icons/go";
import { FiGlobe } from "react-icons/fi";
import { DataProvider } from '../store/ContextProvider';
import Loading from './Loading';

function Employer() {

    const { id } = useParams()
    const { BeURL, showAlert } = useContext(DataProvider)
    const [employer, setEmployer] = useState(null)

    useEffect(()=>{
        if (id && BeURL && showAlert){
            fetchCompany(BeURL, showAlert, id, setEmployer)
        }
    }, [id, BeURL])


    const renderAddress = () => {
        let headquarter = employer.headquarters
        let address = ""

        if(typeof headquarter === "object" && Object.entries(headquarter).length){
            const addressArr = Object.values(headquarter)
            if (addressArr.length){
                addressArr.forEach((add, i) => {
                    if (address.length) {
                        if (addressArr.length === i+1){
                            address += `, ${add}.`
                        }
                        else{
                            address += `, ${add}`
                        }
                    }
                    else {
                        address += add
                    }
                })
            }
        }

        return address || ""
    }

    if (!id || !BeURL || !employer){
        return (
            <Loading/>
        )
    }

    const infoCards = [
        {
            icon: GoPeople,
            title: "Company Size",
            value: employer.companySize || "",
            color: "text-green-600"
        },
        {
            icon: FiGlobe,
            title: "Website",
            value: employer.companyWebsite || "",
            color: "text-purple-600"
        }
    ]

  return (
      <div className="py-6 min-h-[70vh] bg-[#F8F8F8]">

        <div className='p-5 py-6 rounded-xl shadow-sm my-3 flex gap-3 items-center flex-wrap sm:flex-nowrap bg-white'>
            <img className="aspect-square object-contain w-[80px] md:w-[100px] rounded-full shadow" src={renderImgUrl(BeURL, employer.companyLogo, employer.companyName)} alt={employer.companyName || ""} />
            <div>
                <h2 className='font-semibold my-2 text-xl'>{employer.companyName || "N/A"}</h2>
                <p className='flex items-center gap-2'>
                    <PiBuildingOfficeBold className='text-xl text-secondary-300' />
                    {employer.industry || "N/A"}
                </p>
                <div className='flex gap-2 items-center my-2'>
                    <LuMapPin className='text-xl text-secondary-300' />
                    <div>
                        <h3 className='font-medium text-xs'>Head Office</h3>
                        <p>{renderAddress() || "N/A"}</p>
                    </div>
                </div>
            </div>
        </div>

        <div className='flex flex-wrap md:flex-nowrap gap-3 items-stretch my-3'>
            {
                infoCards.map((card, i) => {
                    if (card.value) {
                        return (
                            <div className='p-5 py-6 rounded-xl shadow-sm md:flex-1 text-center bg-white' key={i}>
                                <div className='flex justify-center'>
                                    <card.icon className={`${card.color + " text-3xl"}`} />
                                </div>
                                <h3 className='font-medium my-2'>{card.title || "N/A"}</h3>
                                <p className='text-slate-700 text-sm'>{card.value || "N/A"}</p>
                            </div>
                        )
                    }
                    else return null
                })
            }
        </div>

        <div className='p-5 py-6 rounded-xl shadow-xl my-3  bg-white'>
            <h3 className='font-medium my-2'>Company Bio</h3>
              <p>{employer.description || "N/A"}</p>
        </div>


    </div>
  )
}

export default Employer